import { Injectable } from '@angular/core';

@Injectable()
export class EventLogStateService {

    private state = {
        dateMin : new Date(),
        dateMax : new Date()
    };
    
    constructor() { }

    getState() {
        return this.state;
    }

    setState(state){
        this.state = state;
    }

}